import styled from "styled-components";

export const Header = styled.header`
  padding: 0.6rem 1.8125rem;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;

  .show {
    display: initial;
  }
  .hide {
    display: none;
  }

  .header__burgermenu {
    position: relative;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    .header__burgermenu {
      display: none;
    }
    .hide {
      display: initial;
      color: red;
    }
  }
`;
